import { render, staticRenderFns } from "./CorrectImageUpload.vue?vue&type=template&id=7985e55c&"
import script from "./CorrectImageUpload.vue?vue&type=script&lang=ts&"
export * from "./CorrectImageUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports